import React, { Component } from 'react';
import TwitterIcon from '../../asset/TwitterIcon'
import LogoIcon from '../../asset/Logo';
import { Link } from 'react-router-dom';

const author = "Jinju Jang";

const navigationContent = [
  // {
  //   name: "Work",
  //   pathname: "/"
  // },
  // {
  //   name: "About",
  //   pathname: "about"
  // },
];

const socialLink = [
  // {
  //   name: "Twitter",
  //   pathname: "https://twitter.com/arle13",
  //   icon: <TwitterIcon />,
  // }
]

class Footer extends Component {
  render(){
    return(
      <footer className="footer">
        <div className="grid">
          <div className="container">

            {/* Fancy footer logo */}
            <div className="col col-1 align-center">
              <div className="footer_title">
                  <LogoIcon />
              </div>
            </div>

            {/* Footer navigation menu */}
            <div className="col col-1 col-1-3--l">
              <nav className="nav-footer">
                <ul className="list-inline list-footer">
                  {navigationContent.map(item => (
                    <li key={item.pathname}><Link className="link link-nav" to={item.pathname}>{item.name}</Link></li>
                  ))}
                </ul>
              </nav>
            </div>

            <div className="col col-1 col-1-3--l">
                <p className="copyright">© {new Date().getFullYear()} Designed & Coded by {author}</p>
            </div>

          <div className="col col-1 col-1-3--l">
            <nav className="nav-social">
              <ul className="list-inline list-social">
                {socialLink.map(item => (
                  <li key={item.pathname}> <a href={item.pathname} target="_blank"> {item.icon}</a></li>
                ))}
              </ul>
            </nav>
          </div>
        </div>
        </div>
      </footer>
    );
  }
}
export default Footer;



// WEBPACK FOOTER //
// ./src/layout/footer/Footer.js